import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

export default function ApplyPage() {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const params = searchParams.toString();
    const url = `https://ieum-landing.web.app/apply${params ? `?${params}` : ''}`;
    window.location.replace(url);
  }, [searchParams]);

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', color: '#6B7280', fontSize: 14 }}>
      신청 페이지로 이동 중...
    </div>
  );
}
